<template>
  <div class="class-details-modal">
    <div class="booking-requested">
      <a
        data-w-id="f1724f56-9875-d7e9-bc8a-c9f5249ac362"
        href="#"
        @click="cancel"
        class="link-block-5 w-inline-block"
      >
        <img
          src="@/assets/timeslot-images/cancelIconNew.svg"
          loading="lazy"
          alt=""
        />
      </a>
      <div class="div-block-52">
        <h1 class="modal-heading">Spot secured 🥳</h1>
      </div>
      <p class="paragraph-7">
        You have successfully booked a spot in
        <strong>{{ singleGroupSession.groupSessionTopic }}</strong>
      </p>
      <div class="div-block-85-copy">
        <div class="div-block-86">
          <img
            :src="
              singleProfessional.customerDisplayPicture ||
                require('@/assets/timeslot-images/profileImg.svg')
            "
            loading="lazy"
            width="136"
            alt=""
            class="prof-image"
          />
          <img
            src="@/assets/timeslot-images/checkmark.svg"
            loading="lazy"
            alt=""
            class="image-18"
          />
        </div>

        <div class="text-block-71">
          <strong>{{ singleGroupSession.groupSessionTopic }}</strong> with
          <a href="#" class="link-11">{{ profName }}</a>
        </div>
        <div class="div-block-87">
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-69">
              {{
                new Date(singleGroupSession.groupSessionStartTime.slice(0, 10))
                  .toString()
                  .slice(0, 11)
              }}
            </div>
          </div>
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/money.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-70">
              ${{ singleGroupSession.groupSessionAmount }}
            </div>
          </div>
          <div class="div-block-88">
            <!--            <img-->
            <!--              src="@/assets/timeslot-images/Frame.svg"-->
            <!--              loading="lazy"-->
            <!--              alt=""-->
            <!--              class="image-19"-->
            <!--            />-->
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-70">
              <!--              {{ singleGroupSession.groupSessionMaxAttendance }} students-->
              {{
                formatHours(new Date(singleGroupSession.groupSessionStartTime))
              }}:{{
                formatMinutes(
                  new Date(singleGroupSession.groupSessionStartTime)
                )
              }}
              {{
                formatTime(new Date(singleGroupSession.groupSessionStartTime))
              }}
              -
              {{
                formatHours(new Date(singleGroupSession.groupSessionEndTime))
              }}:{{
                formatMinutes(new Date(singleGroupSession.groupSessionEndTime))
              }}
              {{ formatTime(new Date(singleGroupSession.groupSessionEndTime)) }}
            </div>
          </div>
        </div>
      </div>
      <div class="button-15 w-button" @click="goToCustomerClasses">
        View spot
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import moment from "moment/moment";

export default {
  name: "ClassBookedModal",
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional,
      singleGroupSession: state => state.groupSession.singleGroupSession,
      userInfo: state => state.auth.userInfo
    })
  },
  props: {
    profName: String,
    cancel: Function
  },
  methods: {
    goToCustomerClasses() {
      RouterUtils.changeRouteUrlTo("/customer-classes");
      StoreUtils.commit("groupSession/updateClassBookedSuccess", false);
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    }
  }
};
</script>

<style scoped>
.prof-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>
